import findRootEditableElement from '../find-root-editable-element';
import view from '../../../view';
import isEmptyEditableElement from '../../verifiers/is-empty-editable-element';
import isBreakElement from '../../verifiers/is-break-element';
import insertBreakIntoEmptyEditableElement from '../insert-break-into-empty-editable-element';
import setCaretInTheEndOfNode from '../set-caret-in-the-end-of-node';

/*
/ In Mozila browser, if element has custom elements (ws-color, ws-decoration) as a sibling
/ it doesn't remove all sibling, to fix it we have to manually remove them.
*/

const handleRemoveEmptyChildren = () => {
  const selection = view.accessors.getSelection();

  requestAnimationFrame(() => {
    const { anchorNode } = selection;

    const editableElement = findRootEditableElement(anchorNode);

    if (!editableElement) {
      return;
    }

    if (
      isEmptyEditableElement(editableElement) &&
      !isBreakElement(editableElement.firstElementChild)
    ) {
      editableElement.innerText = '';
      insertBreakIntoEmptyEditableElement(editableElement);
      setCaretInTheEndOfNode(editableElement.firstElementChild);
    }
  });
};

export default handleRemoveEmptyChildren;
